<div class="login-switch">
  <div class="switch-container">
    <button
      type="button"
      class="option-label"
      [class.active]="userType === 'PJ'"
      (click)="setUserType('PJ')">
      Sou empresa
    </button>

    <button
      type="button"
      class="option-label"
      [class.active]="userType === 'FUNC'"
      (click)="setUserType('FUNC')">
      Sou funcionário
    </button>

    <button
      type="button"
      class="option-label"
      [class.active]="userType === 'PF'"
      (click)="setUserType('PF')">
      Sou pessoa física
    </button>
  </div>
</div>
